var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSugarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.894,
    height: 77.893,
    viewBox: "0 0 77.894 77.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.121 2.121)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 73.652,
    y2: 73.65,
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8,33.981a22.416,22.416,0,0,1-31.7,31.7",
    transform: "translate(-2.124 -13.005)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.925,36.838A14.385,14.385,0,0,0,40.732,56.031",
    transform: "translate(-16.899 -13.005)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.485,39.641A14.41,14.41,0,0,1,31.106,60.02",
    transform: "translate(-4.47 -13.005)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.177,50.206c-.006-.127-.037-.247-.037-.375a7.2,7.2,0,0,1,7.205-7.205c.128,0,.248.031.375.037",
    transform: "translate(-15.519 -13.005)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,44.736A7.2,7.2,0,1,1,38.311,54.925",
    transform: "translate(-6.58 -13.005)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.69,61.038,26.3,70.645v-1.6c-.9-3.393-3.2-11.339-3.2-19.213s2.3-15.82,3.2-19.214v-1.6L8.69,38.623",
    transform: "translate(47.35 -13.005)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.404,
    transform: "translate(59.242 36.825)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.404,
    y2: 1.601,
    transform: "translate(57.641 28.82)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.404,
    y1: 1.601,
    transform: "translate(57.641 43.23)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.342,30.965A22.246,22.246,0,0,0,51.054,61.038L33.442,70.645v-1.6c.9-3.393,3.2-11.339,3.2-19.213s-2.3-15.82-3.2-19.214v-1.6l17.612,9.607",
    transform: "translate(-33.442 -13.005)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x2: 6.404,
    transform: "translate(8.006 36.825)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x2: 6.404,
    y2: 1.601,
    transform: "translate(9.607 28.82)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.601,
    x2: 6.404,
    transform: "translate(9.607 43.23)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugarIcon);
export default __webpack_public_path__ + "static/media/sugar-icon.8d6c47ce.svg";
export { ForwardRef as ReactComponent };